export const isJuniorOrSeniorCompany = (companyName) => {
    const juniorSeniorCompanies = ['BE8001_MCC_Junior', 'BE8002_MCC_Senior'];
    return juniorSeniorCompanies.includes(companyName);
};